import { CSSObject } from '@emotion/react';

export enum Breakpoints {
  XS = 480,
  SM = 576,
  MD = 768,
  LG = 976,
  XL = 1440,
}

const screen =
  (breakpoint: number): ((style: CSSObject) => CSSObject) =>
  (style: CSSObject): CSSObject => {
    const key = `@media (max-width: ${breakpoint}px)`;
    return { [key]: style };
  };

export const screenXs = screen(Breakpoints.XS);

export const screenSm = screen(Breakpoints.SM);

export const screenMd = screen(Breakpoints.MD);

export const screenLg = screen(Breakpoints.LG);

export const screenXl = screen(Breakpoints.XL);
